<template>
  <div id="EditConsultationDataContainer" class="vs-con-loading__container">
    <shared-edit-consultation @editConsultationSuccess="editConsultationSuccess"></shared-edit-consultation>
    <div class="text-center">
      <vs-button id="editConsultationButton" class="m-2" color="primary" type="filled" @click.prevent="initSaveConsultationFormData">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancel">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import SharedEditConsultation from '@/views/Shared/Consultations/Consultations/Edit'

export default {
  name: 'Window.Consultation.Edit',
  components: {
    SharedEditConsultation
  },
  data () {
    return {
      memberId: 0,
      consultationId: 0
    }
  },
  mounted () {
    this.memberId = this.$route.params.id
    this.consultationId = this.$route.params.consultationId
    this.loadEditConsultation()
  },
  methods: {
    async loadEditConsultation () {
      EventBus.$emit('initLoadEditConsultation', { id: this.memberId, consultationId: this.consultationId })
    },
    editConsultationSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_consultation_callback_member_table')
      window.close()
    },
    initSaveConsultationFormData () {
      EventBus.$emit('initSaveConsultationFormData')
    },
    cancel () {
      this.$windowOpenerHelper.notifyOpener('reload_consultation_callback_member_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
